import { ProjectService } from '@alpha-core/platform-ui';
import { AdminFilter, INBOX_CONFIG, ListAdminFilters } from '@alpha-core/platform-ui/interfaces/admin-filter.interface';
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Menu } from 'primeng/menu';
import { lastValueFrom } from 'rxjs';
import { AdminFilterService } from '../../services/admin-filter.service';
import { AlphaSharedModule } from '../../shared/alpha-shared.module';
import { PaginationBarComponent } from '../pagination-bar/pagination-bar.component';
import { JoinPipe } from '../users/joinpipe/join.pipe';
import { DeleteCustomListComponent } from './delete-custom-list/delete-custom-list.component';

@Component({
    selector: 'app-admin-filters',
    standalone: true,
    imports: [PaginationBarComponent, JoinPipe, AlphaSharedModule],
    templateUrl: './admin-filters.component.html',
    styles: ``,
})
export class AdminFiltersComponent implements OnInit {
    private message = inject(MessageService);

    private projectService: ProjectService = inject(ProjectService);
    private router: Router = inject(Router);
    private adminFilterService: AdminFilterService = inject(AdminFilterService);
    private dialogService = inject(DialogService);
    adminFilters: AdminFilter[] = [];
    selectedFilters: AdminFilter[] = [];
    actionsOptions: MenuItem[] = [
        {
            label: 'default-cm-edit',
            icon: 'assets/icons/edit-button.svg',
            command: () => {
                this.navigateTo('home/custom-list/edit', this.selectedFilter.filterId);
            },
        },
        {
            label: 'default-cm-delete',
            icon: 'assets/icons/delete-button.svg',
            command: () => {
                this.onDelete();
            },
        },
    ];
    filter: {
        pageSize: number;
        page: number;
        totalCount: number;
        searchKey: string;
    } = { pageSize: 10, page: 0, totalCount: 0, searchKey: '' };
    inboxConfig: Record<string, any> = INBOX_CONFIG;
    selectedFilter!: AdminFilter;
    sortStatus: 'ASC' | 'DESC' = 'DESC';
    sort: { [key: string]: boolean } = {
        filterName: false,
        description: false,
        updatedAt: false,
        createdAt: false,
    };

    ngOnInit(): void {
        this.listAllFilters();
    }

    listAllFilters(sortBy: string = 'updatedAt') {
        if (this.sort[sortBy]) {
            this.sortStatus = this.sortStatus === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.sortStatus = 'ASC';
            Object.keys(this.sort).forEach((sortKey) => {
                this.sort[sortKey] = sortKey === sortBy;
            });
        }
        const filter = {
            search: this.filter.searchKey?.toLocaleLowerCase(),
            pageNumber: this.filter.page,
            pageSize: this.filter.pageSize,
            sort: {
                sortBy,
                sortOrder: this.sortStatus,
            },
        };
        lastValueFrom(this.adminFilterService.listFilters(filter)).then((res: ListAdminFilters | null) => {
            this.adminFilters = res?.records || [];
            this.filter.totalCount = res?.total || 0;
        });
    }
    navigateTo(path: string, filterId?: string) {
        const project = this.projectService.fetchCurrentProject();
        const queryParams: any = {
            projectId: project?.projectId,
        };
        if (filterId) {
            path = path + '/' + filterId;
        }
        this.router.navigate([path], { queryParams });
    }

    openToggleMenu(menu: Menu, filter: AdminFilter, event: MouseEvent) {
        this.selectedFilter = filter;
        event.preventDefault();
        event.stopPropagation();
        menu.toggle(event);
    }

    async onDelete() {
        let data = {},
            filtersToDelete: AdminFilter[] = [];
        if (this.selectedFilters.length) {
            filtersToDelete.push(...this.selectedFilters);
        } else {
            data = { itemName: this.selectedFilter.filterName };
            filtersToDelete.push(this.selectedFilter);
        }
        this.dialogService
            .open(DeleteCustomListComponent, {
                width: '32rem',
                data,
                showHeader: false,
            })
            .onClose.subscribe(async (res: boolean) => {
                if (res) {
                    const results: any[] = await Promise.allSettled(
                        filtersToDelete.map((filter) =>
                            lastValueFrom(this.adminFilterService.deleteFilter(filter.filterId)),
                        ),
                    );

                    const failed = results.some((r) => r.value === 'error');
                    if (!failed) {
                        this.message.add({
                            severity: 'success',
                            summary: 'Success!',
                            detail: 'Successfully deleted filter',
                        });
                        this.listAllFilters();
                    }
                }
            });
    }
}
